<template>
<div class="upload-price">

  <vue-headful
    title="TZ Design Box - Upload Price"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'upload-price'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("upload-price") }}</h2>
          <p>{{ $t("price-upload-details") }}</p>
          <form @submit.prevent="validateBeforeSubmit">
                 <input type="file" class="form-control" v-on:change="upload($event.target.files)" accept=".csv" />
                 <font-awesome-icon icon="spinner" spin size="2x" :class="{'loaderisactive':isActive}" style="display:none;"/>
                       <br><br>
          </form>
          <h2>{{ $t("upload-vartext") }}</h2>
          <p>{{ $t("price-upload-details") }}</p>
          <form @submit.prevent="validateBeforeSubmit">
                 <input type="file" class="form-control" v-on:change="uploadVartext($event.target.files)" accept=".xml" />
                 <font-awesome-icon icon="spinner" spin size="2x" :class="{'loaderisactive':isActive}" style="display:none;"/>
                       <br><br>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert       from '@/components/MenuVert'
import Breadcrumbs    from '@/components/Breadcrumbs'
import { mapGetters } from 'vuex'

export default {
    name:'UploadPrice',
    computed: { ...mapGetters(["getCurrentCompany", "getCompany"])
    },
    data: function () {
        return {
            contact: {},
            isActive: false
        }
    },
    components: {MenuVert, Breadcrumbs},
    methods: {
        upload (files) {
            var self      = this
            self.isActive = !self.isActive
            this.$store.dispatch ('uploadPrice', {files, self})
                .then (() => {
                })
        },
        uploadVartext (files) {
            var self      =  this
            self.isActive = !self.isActive
            this.$store.dispatch ('uploadVartext', {files, self})
                .then (() => {
                })
        },
        uploadTranslation (file) {
            this.isActive = !this.isActive

        }
    },
    created () {
        var self = this
        this.$store.dispatch("callCurrentCompany",{self: self,company: this.getCompany})
    }
}
</script>

<style>
.upload-price{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}

.loaderisactive{
    display:inline-block!important;
}
</style>
